/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTrendingDown2 = createReactComponent("trending-down-2", "IconTrendingDown2", [
  ["path", { d: "M3 6h5l7 10h6", key: "svg-0" }],
  ["path", { d: "M18 19l3 -3l-3 -3", key: "svg-1" }]
]);

export { IconTrendingDown2 as default };
//# sourceMappingURL=IconTrendingDown2.js.map
